// AlarmDetailsContent.js
import React, { useState, useEffect, useReducer } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  IconButton,
  Tooltip,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Button,
  TextField,
  Stack,
  Box,
  Alert,
  Skeleton,
  TableHead,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from "@mui/material";
import dayjs from "dayjs";
import { useTheme } from "@mui/material/styles";
import { RenderProcessNote } from "../StoreDetail/renderProcessNoteTables";
import useMediaQuery from "@mui/material/useMediaQuery";
import NoData from "components/NoData";
import { tlmGetPlantNotes } from "../../apiService";
import TemplateBox from "components/TemplateBox";
import { I18n } from "aws-amplify/utils";
import { RenderDeviceNoteAlarm } from "../StoreDetail/renderDeviceNoteTablesAlarm";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { red, grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { tlmGetDeviceNoteAlarm } from "../../apiService";
import LaunchIcon from "@mui/icons-material/Launch";
import { RenderPlantNote } from "../StoreDetail/renderPlantNoteTable";
import WorkInProgressCard from "../WorkInProgressCard";
import { fetchAlarmsOnSameDevice } from "../../apiService";
import { getStoresColumns } from "./columns";
import { tlmGetAccountAssets } from "../../apiService";
import { tlmGetProcessNotesAlarm } from "../../apiService";
import { RenderProcessNoteAlarm } from "../StoreDetail/renderProcessNoteTablesAlarms";
import SuspensionNote from "../StoreDetail/SuspensionNote";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { tlmGetEventHistory } from "../../apiService";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { EventHistoryTable } from "../StoreDetail/eventHistoreTable";
import ContactNote from "../StoreDetail/ContactNote";
dayjs.extend(utc);
dayjs.extend(timezone);

function alarmsSameDevReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
function processDeviceReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
function noteDeviceReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
function assetReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
function notePlantReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
function eventHistoryReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
const initialState = {
  loading: true,
  data: null,
  error: null,
};
const ActionComponent = ({ selectedRow }) => {
  const navigate = useNavigate();
  return (
    <Tooltip title="View Details">
      <IconButton
        onClick={() => navigate(`/cases/${selectedRow.sf_ticket_number}`)}
      >
        <LaunchIcon />
      </IconButton>
    </Tooltip>
  );
};
function AlarmDetailsContent({
  data,
  loading,
  alarmID,
  language,
  profile,
  alarmRateData,
  fetchLists,
}) {
  // console.log("DATA", data);
  const combinedData = {
    ...data, // Include i dettagli esistenti in data
    ...alarmRateData, // Aggiungi i dati da alarmRateData
  };
  const durationOptions = [
    { value: 1, label: I18n.get("1 hour") },
    { value: 3, label: I18n.get("3 hours") },
    { value: 6, label: I18n.get("6 hours") },
    { value: 12, label: I18n.get("12 hours") },
    { value: 24, label: I18n.get("24 hours") },
    { value: "1w", label: I18n.get("Last 7 days") },
  ];
  const [isMessageExpanded, setIsMessageExpanded] = useState(false);
  const theme = useTheme();
  const [devicePlantState, dispatchDevicePlant] = useReducer(
    noteDeviceReducer,
    initialState
  );
  const [notePlantState, dispatchNotePlant] = useReducer(
    notePlantReducer,
    initialState
  );
  const [deviceProscessState, dispatchProcessPlant] = useReducer(
    processDeviceReducer,
    initialState
  );
  const isMobileDevice = useMediaQuery("(max-width:600px)");
  const [endDate, setEndDate] = useState(dayjs().endOf("day"));
  const [startDate, setStartDate] = useState(
    dayjs(endDate).subtract(48, "hour")
  );
  const [endDateDev, setEndDateDev] = useState(dayjs().endOf("day"));
  const [startDateDev, setStartDateDev] = useState(
    dayjs(endDate).subtract(48, "hour")
  );
  const [endDateHist, setEndDateHist] = useState(dayjs().endOf("day"));
  const [startDateHisr, setStartDateHist] = useState(
    dayjs(endDate).subtract(48, "hour")
  );
  const [alarmsSameDevState, dispatchAlarmsSameDev] = useReducer(
    alarmsSameDevReducer,
    initialState
  );
  const [assetState, dispatchAssetState] = useReducer(
    assetReducer,
    initialState
  );
  const [eventState, dispatchEventState] = useReducer(
    eventHistoryReducer,
    initialState
  );
  const [alarmsSameDevPage, setAlarmsSameDevPage] = useState(0);
  const [rowsPerAlarmsSameDevPage, setRowsPerAlarmsSameDevPage] = useState(5);
  const [resourcePrefPage, setResourcePrefPage] = useState(0);
  const [rowsPerResourcePrefPage, setRowsPerResourcePrefPage] = useState(5);
  const storesColumns = getStoresColumns();
  const [duration, setDuration] = useState(24); // Default to 24 hours

  const handleDurationChange = (selectedValue) => {
    setDuration(selectedValue);

    // Calcola startDate e endDate
    const now = new Date();
    let startDate;
    if (selectedValue === "1w") {
      // Per gli ultimi 7 giorni
      startDate = new Date();
      startDate.setDate(now.getDate() - 7); // Sottrai 7 giorni
    } else {
      // Per le ore
      startDate = new Date();
      startDate.setHours(now.getHours() - selectedValue); // Sottrai ore
    }

    // Format Date
    const formattedStartDate = startDate.toISOString(); // Puoi formattare diversamente se necessario
    const formattedEndDate = now.toISOString(); // Fine periodo è sempre ora corrente
  };

  const formatTimestamp = (value) => {
    if (!value) {
      return ""; // Gestisce valori null o undefined
    }
    return dayjs
      .utc(value) // Interpreta il valore come UTC
      .tz(dayjs.tz.guess()) // Converte al fuso orario locale
      .format("YYYY-MM-DD HH:mm:ss"); // Formato desiderato
  };

  const assetColumns = [
    {
      id: "fsl_name_and_serial_number",
      label: I18n.get("Name"),
      align: "left",
      flex: 1,
      rendercell: (params) => {
        return (
          <Typography
            component="a"
            href={`https://eptarefrigeration.lightning.force.com/${params.row.id}`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontSize: "medium",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {params.value}
          </Typography>
        );
      },
    },
    {
      id: "system_technology",
      label: I18n.get("Technology"),
      align: "left",
      flex: 1,
    },
    {
      id: "type_of_ip_connect",
      label: I18n.get("Type of IP Connect"),
      align: "left",
      flex: 1,
    },
    {
      id: "number_of_monitored_devices",
      label: I18n.get("N. Devices"),
      align: "left",
      flex: 1,
    },
    {
      id: "fsl_url_link",
      label: I18n.get("Direct Link"),
      align: "left",
      flex: 1,
      rendercell: (params) => {
        return (
          <Typography
            component="a"
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontSize: "medium",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {I18n.get("Open link")}
          </Typography>
        );
      },
    },
  ];

  const headerCells = [
    {
      id: "name",
      label: I18n.get("Store Name"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <Typography
          component="a"
          href={`https://eptarefrigeration.lightning.force.com/${params.row.account_id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      id: "source_technology",
      label: I18n.get("Source Technology"),
      align: "left",
      flex: 1,
    },
    {
      id: "alarm_type_description",
      label: I18n.get("Alarm Type Description"),
      align: "left",
      flex: 1,
    },
    {
      id: "datetime_start",
      label: I18n.get("Start Date"),
      align: "left",
      flex: 1,
      renderCell: (params) => formatTimestamp(params.value),
    },
    {
      id: "severity",
      label: I18n.get("Severity"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: "50%",
            border: `2px solid ${params.row.color}`,
            backgroundColor: params.row.color,
            color: "#fff",
            fontSize: "12px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      id: "original_priority",
      label: I18n.get("Priority"),
      align: "left",
      flex: 1,
    },
    {
      id: "state",
      label: I18n.get("State"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <>
          {params.value === "1" ? (
            <WarningIcon sx={{ width: 20, height: 20, color: red[500] }} />
          ) : (
            <CheckCircleIcon sx={{ width: 20, height: 20, color: grey[500] }} />
          )}
        </>
      ),
    },
    {
      id: "original_equipment",
      label: I18n.get("Original Equipment"),
      flex: 1,
      align: "left",
    },
    { id: "id", label: I18n.get("ID"), align: "left", flex: 1 },
    { id: "system_id", label: I18n.get("System ID"), align: "left", flex: 1 },
    {
      id: "alarm_text",
      label: I18n.get("Alarm Text"),
      align: "left",
      flex: 1,
    },
    {
      id: "original_message",
      label: I18n.get("Message"),
    },
    { id: "last_modifier", label: I18n.get("Last Modifier") },
    { id: "last_modification_type", label: I18n.get("Last Modification Type") },
    {
      id: "last_modification_date",
      label: I18n.get("Last Modification Date"),
      renderCell: (params) => formatTimestamp(params.value),
    },
    { id: "account_number", label: I18n.get("Account Number") },
    { id: "retailer", label: I18n.get("Retailer"), align: "left", flex: 1 },
    {
      id: "billing_country",
      label: I18n.get("Country"),
      align: "left",
      flex: 1,
    },
    { id: "billing_city", label: I18n.get("City"), align: "left", flex: 1 },
    { id: "billing_street", label: I18n.get("Street"), align: "left", flex: 1 },
    {
      id: "datetime_close",
      label: I18n.get("Close Date"),
      align: "left",
      flex: 1,
      renderCell: (params) => formatTimestamp(params.value),
    },
    {
      id: "case_number",
      label: I18n.get("Case Number"),
      align: "left",
      flex: 1,
      rendercell: (params) => {
        // Check if case_number is not empty
        if (!params.value) {
          return null; // Render nothing if the value is empty
        }

        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              component="a"
              href={
                process.env.REACT_APP_ENV_ENVIRONMENT != "prod"
                  ? `https://eptarefrigeration--bugfix.sandbox.lightning.force.com${params.row.case_id}`
                  : `https://eptarefrigeration.lightning.force.com/${params.row.case_id}`
              }
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontSize: "medium",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {params.value}
            </Typography>
          </Box>
        );
      },
    },

    { id: "duration", label: I18n.get("Duration"), align: "left", flex: 1 },
  ];

  const frequencyCell = [
    {
      id: "one_day_frequency",
      label: I18n.get("One Day Frequency"),
      align: "left",
      flex: 1,
    },
    {
      id: "one_week_frequency",
      label: I18n.get("One Week Frequency"),
      align: "left",
      flex: 1,
    },
  ];
  // useEffect(() => {
  //   if (!loading && data && data.account_number) {
  //     const fetchData = async () => {
  //       dispatchAlarmsSameDev({ type: "LOADING" });

  //       try {
  //         // Ottieni l'orario attuale in UTC
  //         const now = dayjs().utc();
  //         let startDateTimeUTC;
  //         const endDateTimeUTC = now.format(); // L'end time è sempre il momento attuale

  //         // Calcola lo start time in base alla durata selezionata
  //         if (duration === "1w") {
  //           // Durata: ultimi 7 giorni
  //           startDateTimeUTC = now.subtract(7, "day").format();
  //         } else {
  //           // Durata in ore
  //           startDateTimeUTC = now.subtract(duration, "hour").format();
  //         }

  //         const response = await fetchAlarmsOnSameDevice(
  //           data.account_number,
  //           data.id,
  //           language,
  //           startDateTimeUTC,
  //           endDateTimeUTC
  //         );

  //         dispatchAlarmsSameDev({ type: "DATA_RECEIVED", value: response });
  //       } catch (error) {
  //         dispatchAlarmsSameDev({ type: "ERROR", error });
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [loading, data, language, duration]);

  useEffect(() => {
    if (!loading && data && data.account_number) {
      const fetchData = async () => {
        try {
          const response = await tlmGetAccountAssets(data.account_id);
          dispatchAssetState({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
          dispatchAssetState({ type: "ERROR", error });
        }
      };
      fetchData();
    }
  }, [loading, data, language]);

  useEffect(() => {
    if (!loading && data) {
      const fetchData = async () => {
        try {
          const response = await tlmGetEventHistory(
            startDateHisr,
            endDateHist,
            data.id
          );
          dispatchEventState({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
          dispatchEventState({ type: "ERROR", error });
        }
      };
      fetchData();
    }
  }, [loading, data, language, startDateHisr, endDateHist]);
  useEffect(() => {
    if (!loading && data && data.account_number) {
      const fetchData = async () => {
        try {
          const response = await tlmGetPlantNotes(
            data.account_number,
            endDate,
            startDate
          );
          dispatchNotePlant({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
          dispatchNotePlant({ type: "ERROR", error });
        }
      };
      fetchData();
    }
  }, [loading, data, language, endDate, startDate]);
  useEffect(() => {
    if (!loading && data && data.account_number) {
      const fetchData = async () => {
        try {
          const response = await tlmGetDeviceNoteAlarm(
            data.account_number,
            endDateDev,
            startDateDev,
            data.alarm_type_id,
            data.original_equipment,
            language
          );
          dispatchDevicePlant({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
          dispatchDevicePlant({ type: "ERROR", error });
        }
      };
      fetchData();
    }
  }, [loading, data, language, endDateDev, startDateDev, language]);
  useEffect(() => {
    if (!loading && data && data.account_number) {
      const fetchData = async () => {
        try {
          const response = await tlmGetProcessNotesAlarm(
            data.account_number,
            endDateDev,
            startDateDev,
            data.original_equipment,
            language
          );
          dispatchProcessPlant({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
          dispatchProcessPlant({ type: "ERROR", error });
        }
      };
      fetchData();
    }
  }, [loading, data, language, endDateDev, startDateDev, language]);
  const renderOriginalMessageCell = (params) => {
    return (
      <>
        {params.value && params.value.length > 15 && !isMessageExpanded ? (
          `${params.value.substring(0, 15)}...`
        ) : (
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              display: "block",
              whiteSpace: "normal",
              wordBreak: "break-all",
            }}
          >
            {params.value || ""}
          </Typography>
        )}
        {params.value && params.value.length > 15 && (
          <Button
            onClick={() => setIsMessageExpanded(!isMessageExpanded)}
            size="small"
            color="primary"
          >
            {isMessageExpanded ? "Read Less" : "Read More"}
          </Button>
        )}
      </>
    );
  };

  const updatedHeaderCells = headerCells.map((column) => {
    if (column.id === "original_message") {
      return {
        ...column,
        rendercell: renderOriginalMessageCell,
      };
    }
    return column;
  });

  const renderTableBody = () => {
    if (!loading && (!combinedData || combinedData.length === 0)) {
      return (
        <Card>
          <CardContent>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ pb: 2 }}
            >
              <Typography variant="h5">{I18n.get("Alarm Details")}</Typography>
            </Stack>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NoData />
            </Box>
          </CardContent>
        </Card>
      );
    }

    return (
      <Card>
        <CardContent sx={{ padding: "1rem" }}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5"> {I18n.get("Alarm Details")}</Typography>
          </Stack>
          {!loading && !combinedData.name && (
            <Grid item xs={12} mb={2}>
              <Alert severity="warning">
                {I18n.get("The store assignment was not successful")}
              </Alert>
            </Grid>
          )}
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {updatedHeaderCells.map((column, colIndex) => (
                  <React.Fragment key={colIndex}>
                    <TableCell
                      style={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        padding: "0.5rem",
                        borderBottom: "1px solid #e0e0e0",
                        fontSize: "0.875rem",
                        lineHeight: 1.6,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        {column.label}:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        {loading ? (
                          <Skeleton />
                        ) : column.rendercell ? (
                          column.rendercell({
                            value: combinedData[column.id],
                            row: combinedData,
                          })
                        ) : [
                            "datetime_start",
                            "last_modification_date",
                            "datetime_close",
                          ].includes(column.id) ? (
                          combinedData[column.id] ? (
                            formatTimestamp(combinedData[column.id])
                          ) : (
                            ""
                          ) // Display empty if date is null or undefined
                        ) : combinedData[column.id] !== undefined &&
                          combinedData[column.id] !== null ? (
                          combinedData[column.id]
                        ) : (
                          ""
                        )}
                      </Typography>
                    </TableCell>

                    {(colIndex + 1) % (isMobileDevice ? 1 : 2) === 0 && (
                      <TableRow key={`spacer-${colIndex}`}></TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    );
  };

  const renderFrequencyTable = () => {
    if (!loading && (!combinedData || combinedData.length === 0)) {
      return (
        <Card>
          <CardContent>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ pb: 2 }}
            >
              <Typography variant="h5">{I18n.get("Frequency")}</Typography>
            </Stack>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NoData />
            </Box>
          </CardContent>
        </Card>
      );
    }

    return (
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          paddingTop: "0.75rem",
          gap: { xs: "0px", sm: "1rem", xl: "1rem" },
          marginBottom: "1rem",
        }}
      >
        {!loading && !combinedData.name && (
          <Grid item xs={12}>
            <Alert severity="warning">
              {I18n.get("The store assignment was not successful")}
            </Alert>
          </Grid>
        )}
        {frequencyCell.map((column, colIndex) => (
          <Card key={colIndex} sx={{ flex: "1 1 auto" }}>
            <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"0.3rem"}}}>
              <TableContainer>
                <Table sx={{ border: "none" }}>
                  <TableBody>
                    <TableCell
                      style={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        padding: " 0px",
                        border: "none",

                        // fontSize: "14px",
                        // lineHeight: 1.6,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "0.95rem",
                        }}
                      >
                        {column.label}:
                      </Typography>
                      <Box mt={2} />
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "1rem",
                        }}
                      >
                        {loading ? (
                          <Skeleton />
                        ) : column.rendercell ? (
                          column.rendercell({
                            value: combinedData[column.id],
                            row: combinedData,
                          })
                        ) : [
                            "datetime_start",
                            "last_modification_date",
                            "datetime_close",
                          ].includes(column.id) ? (
                          combinedData[column.id] ? (
                            formatTimestamp(combinedData[column.id])
                          ) : (
                            ""
                          ) // Display empty if date is null or undefined
                        ) : combinedData[column.id] !== undefined &&
                          combinedData[column.id] !== null ? (
                          combinedData[column.id]
                        ) : (
                          ""
                        )}
                      </Typography>
                    </TableCell>

                    {(colIndex + 1) % (isMobileDevice ? 1 : 2) === 0 && (
                      <TableRow key={`spacer-${colIndex}`}></TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        ))}
      </Stack>
    );
  };

  function renderAsset() {
    if (assetState.loading) {
      return (
        <Card>
          <CardContent>
            <Skeleton variant="rectangular" width="100%" height={400} />
          </CardContent>
        </Card>
      );
    }

    if (!assetState.data || assetState.data.length === 0) {
      return (
        <Card>
          <CardContent>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ pb: 2 }}
            >
              <Typography variant="h5">
                {I18n.get("Telemonitoring Asset")}
              </Typography>
            </Stack>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NoData />
            </Box>
          </CardContent>
        </Card>
      );
    }

    return (
      <Card >
        <CardContent sx={{ padding: "1rem" }}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5">
              {I18n.get("Telemonitoring Asset")}
            </Typography>
          </Stack>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {assetColumns.map((column) => (
                    <TableCell key={column.id}>{column.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {assetState.data
                  .slice(
                    resourcePrefPage * rowsPerResourcePrefPage,
                    resourcePrefPage * rowsPerResourcePrefPage +
                      rowsPerResourcePrefPage
                  )
                  .map((mappingRow, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {assetColumns.map((column, colIndex) => (
                        <TableCell key={colIndex} style={{padding:"0px"}}>
                          {column.rendercell
                            ? column.rendercell({
                                value: mappingRow[column.id],
                                row: mappingRow,
                              })
                            : mappingRow[column.id] !== undefined &&
                              mappingRow[column.id] !== null
                            ? mappingRow[column.id]
                            : ""}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={assetState.data.length}
            page={resourcePrefPage}
            onPageChange={(event, newPage) => setResourcePrefPage(newPage)}
            rowsPerPage={rowsPerResourcePrefPage}
            onRowsPerPageChange={(event) => {
              setRowsPerResourcePrefPage(parseInt(event.target.value, 10));
              setResourcePrefPage(0);
            }}
            rowsPerPageOptions={[]}
          />
        </CardContent>
      </Card>
    );
  }

  function renderAlarmsOnSameDevice() {
    if (alarmsSameDevState.loading) {
      return (
        <Card>
          <CardContent>
            <Skeleton variant="rectangular" width="100%" height={400} />
          </CardContent>
        </Card>
      );
    }

    if (!alarmsSameDevState.data || alarmsSameDevState.data.length === 0) {
      return (
        <Card>
          <CardContent>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ pb: 2 }}
            >
              <Typography variant="h5">
                {I18n.get("Alarms on Same Store - Last ") +
                  (duration === "1w" ? I18n.get("7 Days") : `${duration}H`)}
              </Typography>
            </Stack>
            <Box sx={{ width: "200px" }}>
              <FormControl margin="dense" fullWidth>
                <InputLabel>{I18n.get("Duration")}</InputLabel>
                <Select
                  label="Duration"
                  value={duration}
                  onChange={(e) => handleDurationChange(e.target.value)}
                >
                  {durationOptions.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NoData />
            </Box>
          </CardContent>
        </Card>
      );
    }

    return (
      <Card>
        <CardContent>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5">
              {I18n.get("Alarms on Same Store - Last ") +
                (duration === "1w" ? I18n.get("7 Days") : `${duration}H`)}
            </Typography>
          </Stack>
          <Box sx={{ width: "200px" }}>
            <FormControl margin="dense" fullWidth>
              <InputLabel>{I18n.get("Duration")}</InputLabel>
              <Select
                label="Duration"
                value={duration}
                onChange={(e) => handleDurationChange(e.target.value)}
              >
                {durationOptions.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {storesColumns.map((column) => (
                    <TableCell key={column.id}>{column.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {alarmsSameDevState.data
                  .slice(
                    alarmsSameDevPage * rowsPerAlarmsSameDevPage,
                    alarmsSameDevPage * rowsPerAlarmsSameDevPage +
                      rowsPerAlarmsSameDevPage
                  )
                  .map((mappingRow, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {storesColumns.map((column, colIndex) => (
                        <TableCell key={colIndex}>
                          {column.rendercell
                            ? column.rendercell({
                                value: mappingRow[column.id],
                                row: mappingRow,
                              })
                            : mappingRow[column.id] !== undefined &&
                              mappingRow[column.id] !== null
                            ? mappingRow[column.id]
                            : ""}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={alarmsSameDevState.data.length}
            page={alarmsSameDevPage}
            onPageChange={(event, newPage) => setAlarmsSameDevPage(newPage)}
            rowsPerPage={rowsPerAlarmsSameDevPage}
            onRowsPerPageChange={(event) => {
              setRowsPerAlarmsSameDevPage(parseInt(event.target.value, 10));
              setAlarmsSameDevPage(0);
            }}
            rowsPerPageOptions={[]}
          />
        </CardContent>
      </Card>
    );
  }

  const renderNotesCard = () => {
    return (
      <Card sx={{ width: "100%" }}>
        <CardContent>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          ></Stack>
          <TableContainer sx={{ width: "100%" }}>
            <Table sx={{ width: "100%" }}>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      wordBreak: "break-all",
                      maxWidth: "100%",
                      padding: "12px 16px",
                      fontSize: "14px",
                      lineHeight: 1.6,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "15px",
                        display: "block",
                      }}
                    >
                      {I18n.get("Contact Notes")}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                        display: "block",
                        whiteSpace: "normal",
                        wordBreak: "break-all",
                      }}
                    >
                      {loading ? <Skeleton /> : data.secondary_note || ""}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    );
  };
  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    }else if(userAgent.includes("Chrome")){
      return "Chrome"
    }
  }
  const browser=getBrowserName();
  return (
    <Box marginBottom={browser==="Firefox"? "83px":browser==="Chrome"?"12px":"0px"}  >
    <TemplateBox mt={1} mb={1}>
      <Grid container spacing={0.5} >
        <Grid item xs={12} md={12} lg={12} mb={0} >
          <TemplateBox px={2} sx={{p:0}}>{renderFrequencyTable()}</TemplateBox>
        </Grid>
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox px={2} sx={{p:0}}>{renderAsset()}</TemplateBox>
        </Grid>
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox px={2} sx={{p:0}}>
            <RenderPlantNote
              notePlantState={notePlantState}
              resourcePrefPage={resourcePrefPage}
              rowsPerResourcePrefPage={rowsPerResourcePrefPage}
              setResourcePrefPage={setResourcePrefPage}
              setRowsPerResourcePrefPage={setRowsPerResourcePrefPage}
              account_number={data.account_number}
              endDate={endDate}
              startDate={startDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              dispatchNotePlant={dispatchNotePlant}
              profile={profile}
            />
          </TemplateBox>
        </Grid>
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox px={2} sx={{p:0}}>
            <RenderDeviceNoteAlarm
              devicePlantState={devicePlantState}
              resourcePrefPage={resourcePrefPage}
              rowsPerResourcePrefPage={rowsPerResourcePrefPage}
              setResourcePrefPage={setResourcePrefPage}
              setRowsPerResourcePrefPage={setRowsPerResourcePrefPage}
              account_number={data.account_number}
              endDate={endDateDev}
              startDate={startDateDev}
              setEndDate={setEndDateDev}
              setStartDate={setStartDateDev}
              dispatchDevicePlant={dispatchDevicePlant}
              AlarmTypeID={data.alarm_type_id}
              OriginalEquipment={data.original_equipment}
              profile={profile}
              language={language}
            />
          </TemplateBox>
        </Grid>
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox px={2} sx={{p:0}}>
            <RenderProcessNoteAlarm
              deviceProscessState={deviceProscessState}
              resourcePrefPage={resourcePrefPage}
              rowsPerResourcePrefPage={rowsPerResourcePrefPage}
              setResourcePrefPage={setResourcePrefPage}
              setRowsPerResourcePrefPage={setRowsPerResourcePrefPage}
              account_number={data.account_number}
              endDate={endDateDev}
              startDate={startDateDev}
              setEndDate={setEndDateDev}
              setStartDate={setStartDateDev}
              dispatchProcessPlant={dispatchProcessPlant}
              profile={profile}
            />
          </TemplateBox>
        </Grid>
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox px={2} sx={{p:0}}>
            <SuspensionNote
              data={data}
              profile={profile}
              fetchLists={fetchLists}
            />
          </TemplateBox>
        </Grid>

        {/* <Grid item xs={12} md={12} lg={12}>
          <TemplateBox pt="1px" px={2}>
          {renderTableBody()}
          </TemplateBox>
        </Grid> */}

        
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox px={2} sx={{p:0}}>{renderTableBody()}</TemplateBox>
        </Grid>
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <TemplateBox sx={{p:0}} px={2}>
            {/** tabella cronologia eventi */}
            <EventHistoryTable
              eventState={eventState}
              resourcePrefPage={resourcePrefPage}
              rowsPerResourcePrefPage={rowsPerResourcePrefPage}
              setResourcePrefPage={setResourcePrefPage}
              setRowsPerResourcePrefPage={setRowsPerResourcePrefPage}
              account_number={data.account_number}
              endDate={endDateHist}
              startDate={startDateHisr}
              setEndDate={setEndDateHist}
              setStartDate={setStartDateHist}
              dispatchProcessPlant={dispatchProcessPlant}
              profile={profile}
            />
          </TemplateBox>
        </Grid>
        {/* <Grid item xs={12} md={12} lg={12}>
          <TemplateBox pt="1px" px={2}>
            <WorkInProgressCard title={I18n.get("Advanced Machine Learning Insights")} />
          </TemplateBox>
        </Grid> */}
      </Grid>
    </TemplateBox>
    </Box>
  );
}

AlarmDetailsContent.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  alarmID: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

AlarmDetailsContent.defaultProps = {
  loading: false,
};

export default AlarmDetailsContent;
